import React from 'react'
import { Card, Row, Col, Badge } from 'react-bootstrap'
import {QRCodeDisplay} from "../../../components/QRCodeDisplay";

interface Props {
  bankDetails: any
    amount:number
    purpose:string
}
export const BankDetailsCard: React.FC<Props> = ({ bankDetails , amount,purpose}) => {
 /**
 * Generate a UPI payment URL using receiver details and transaction info.
 *
 * @param {string} upiId - UPI ID of the receiver (e.g., 9555478755@jio)
 * @param {number|string} amount - Amount to be paid (e.g., 500.00)
 * @param {string} purpose - Purpose or note of the payment (e.g., "Booking Token")
 * @param {string} name - Receiver's name (e.g., "Vivek Srivastava")
 * @returns {string} - A complete UPI deeplink URL
 */
function generateUpiUrl(upiId, amount, purpose, name) {
  const baseUrl = 'upi://pay'
  const params = new URLSearchParams({
    pa: upiId,                   // Payee address
    pn: name,                    // Payee name
    am: amount.toString(),       // Amount as string
    cu: 'INR',                   // Currency
    tn: purpose                  // Transaction note
  })

  return `${baseUrl}?${params.toString()}`
}

  return (

        <Row>
            <Col md={6} sm={12}>
                <p><strong>Company Name:</strong> {bankDetails.company_name}</p>
                <p><strong>Bank Name:</strong> {bankDetails.bank_name}</p>
                <p><strong>Account Number:</strong> {bankDetails.account_number}</p>
                <p><strong>IFSC Code:</strong> {bankDetails.ifsc_code}</p>

                <p><strong>Branch Name:</strong> {bankDetails.branch_name}</p>
            <p><strong>UPI ID:</strong> {bankDetails.upi_id}</p>
          </Col>
            <Col md={6} sm={12}>
                <strong>Scan this UPI QR Code to pay:</strong>
                <br/><br/>
                <QRCodeDisplay value={
                    generateUpiUrl(bankDetails.upi_id, amount, purpose, bankDetails.company_name)}/>
            </Col>
        </Row>

  )
}
